module.exports = __webpack_public_path__ + "static/media/connect_cables2.72f521aa.jpg";